<div class="container">
  <div class="grey"></div>

  <div class="progress" [style.width]="progress">
    <img src="assets/images/performance-new.png" alt="bar" />
  </div>

</div>
